import { render } from "./AddPhone.vue?vue&type=template&id=2683964f&scoped=true"
import script from "./AddPhone.vue?vue&type=script&lang=js"
export * from "./AddPhone.vue?vue&type=script&lang=js"

import "./AddPhone.vue?vue&type=style&index=0&id=2683964f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2683964f"]])

export default __exports__